import Folder from "utils/interfaces/common/Folder";

function replaceFolder(folders: Folder[], newFolders: Folder[]) {
  folders = newFolders;
  return folders;
}

export default replaceFolder;
